module.exports = __webpack_public_path__ + "static/media/alert.897aaf12.svg";